import { render, staticRenderFns } from "./BackgroundFamilyViolence.vue?vue&type=template&id=6f0dcd89"
import script from "./BackgroundFamilyViolence.vue?vue&type=script&lang=ts"
export * from "./BackgroundFamilyViolence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports